export default "__VITE_ASSET__BLemBsNd__"